<div class="radioInput">
  <div *ngIf="isTeacher" class="radioInput__tooltip tooltip--visible">
    <span>{{ teacherSolution }}</span>
  </div>
  <label class="radioContainer" [ngClass]="{ correct: validated && isCorrect, wrong: validated && !isCorrect }">
    <input type="radio" [name]="controlName" [checked]="checked" [disabled]="disabled" [id]="id" />
    <span class="checkmark"></span>
    <div [innerHtml]="safeHtml"></div>
  </label>
</div>
